// extracted by mini-css-extract-plugin
export default {"bodyEmphasis":"_2mHV8c4ZhDfx7xJzyFEtI5"};